import { httpClient } from '@bcba/client-auth';
import {
  DigitalDossierGeneralInformationSerializer,
  DigitalDossierBankingInformationSerializer,
  DigitalDossierRepresentantInformationSerializer,
  ExplorerDigitalDossierTaxInformationSerializer,
} from '@bcba/serializers';
import {
  ExplorerUpsertDigitalDossierFormsAndDocsInformationDto,
  UpdateDigitalDossierGeneralInformationDto,
  UpdateDigitalDossierTaxInformationDto,
  UpsertDigitalDossierBankingInformationDto,
} from '../types/query-params';
import { UpsertExplorerDigitalDossierLegalRepresentantInformationDto } from '../../components/DigitalDossier/DigitalDossierSection/LegalRepresentatives/dto/upsertGeneralInformationDto';
import { basePath } from '.';

export const updateGeneralInformation = async (
  dto: UpdateDigitalDossierGeneralInformationDto,
): Promise<DigitalDossierGeneralInformationSerializer> => {
  const { data } = await httpClient.patch(basePath, dto);
  return data;
};

export const updateBankingInformation = async (
  dto: UpsertDigitalDossierBankingInformationDto,
): Promise<DigitalDossierBankingInformationSerializer> => {
  const { data } = await httpClient.patch(
    `${basePath}/banking-information`,
    dto,
  );
  return data;
};

export const updateLegalRepresentativesInformation = async (
  dto: UpsertExplorerDigitalDossierLegalRepresentantInformationDto,
): Promise<DigitalDossierRepresentantInformationSerializer> => {
  const { data } = await httpClient.patch(
    'digital-dossiers/representant-information',
    dto,
  );

  return data;
};

export const updateTaxInformation = async (
  dto: UpdateDigitalDossierTaxInformationDto,
): Promise<ExplorerDigitalDossierTaxInformationSerializer> => {
  const { data } = await httpClient.patch(
    'digital-dossiers/tax-information',
    dto,
  );

  return data;
};

export const updateFormsAndDocsInformation = async (
  dto: ExplorerUpsertDigitalDossierFormsAndDocsInformationDto,
): Promise<any> => {
  // todo: create serializer and use it as type here
  const { data } = await httpClient.put(
    'digital-dossiers/company-forms-and-docs',
    dto,
  );

  return data;
};
